import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import Select from 'react-select';
import './Attendence.css';
import { selectStyles } from '../../../assets/Styles/selectStyle';
import { getDistrict, getProject, getStates, fetchMonths, getEmployeeForAttendance, getClients } from '../../../services/monthlyAttendanceService';
import { capitalizeFirstLetter } from '../../../utils/validations';
const Attendence = () => {
  const [state, setState] = useState(3);
  const [district, setDistrict] = useState(null);
  const [month, setMonth] = useState(null);
  const [year, setYear] = useState(null);
  const [stateOptions, setStateOptions] = useState([]);
  const [districtOptions, setDistrictOptions] = useState([]);
  const [monthOptions, setMonthOptions] = useState([]);
  const [projectResponse, setProjectResponse] = useState([]);
  const [project, setProject] = useState(null);
  const [clientResponse, setClientResponse] = useState([]);
  const [clients, setClients] = useState(null);
  const effectRan = useRef(false);
  const [errors, setErrors] = useState({});
  const [holidays, setHolidays] = useState([]);
  const [isHoliday, setIsHoliday] = useState(false);
  const [attendanceData, setAttendanceData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [statusErrors, setStatusErrors] = useState([]);
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const [isFocused, setIsFocused] = useState({
    state: false,
    district: false,
    month: false,
    year: false,
    project: false,
    clients: false,
  });
  const [date, setDate] = useState(() => {
    const today = new Date();
    return today.toISOString().split('T')[0];
  });

  const todayDate = new Date().toISOString().split('T')[0];
  const isSunday = new Date(date).getDay() === 0;
  const isValid =
    attendanceData.some(emp => emp.attendanceStatus === 'Present' || emp.attendanceStatus === 'Absent' || emp.attendanceStatus === 'Casual') &&
    !isSunday &&
    !isHoliday;

  // Fetch states
  useEffect(() => {
    const fetchStates = async () => {
      try {
        // const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/states/nationality/1`);
        const data = await getStates();
        setStateOptions(
          data.map(item => ({
            value: item.id,
            label: capitalizeFirstLetter(item.stateName),
          }))
        );
      } catch (error) {
        console.error('Error fetching states:', error);
        setErrors(prev => ({ ...prev, general: 'Failed to load states' }));
      }
    };
    if (!effectRan.current) {
      fetchStates();
    }
    return () => {
      effectRan.current = true;
    }
  }, []);

  // Fetch districts when state changes
  useEffect(() => {
    if (state) {
      const fetchDistricts = async () => {
        try {
          const data = await getDistrict(state);
          setDistrictOptions(
            data.map(item => ({
              value: item.districtId,
              label: item.districtName,
            }))
          );
        } catch (error) {
          console.error('Error fetching districts:', error);
          setErrors(prev => ({ ...prev, general: 'Failed to load districts' }));
        }
      };
      fetchDistricts();
    } else {
      setDistrictOptions([]);
      setDistrict(null);
    }
  }, [state]);

  useEffect(() => {
    if (state) {
      const fetchClients = async () => {
        try {
          const data = await getClients(state);
          setClientResponse(
            data.map(client => ({
              value: client.id,
              label: client.clientName,
            }))
          );
        } catch (error) {
          console.error('Error fetching clients:', error);
          setErrors(prev => ({ ...prev, clients: 'Failed to load clients' }));
        }
      };
      fetchClients();
    } else {
      setClientResponse([]);
      setClients(null);



    }
  }, [state]);
  useEffect(() => {
    if (clients) {
      const fetchProjects = async () => {
        try {
          const data = await getProject(clients);
          setProjectResponse(data.map(pro => ({
            value: pro.id,
            label: pro.projectCode,
          })));
        } catch (error) {
          console.error('Error fetching projects:', error);
          setErrors(prev => ({ ...prev, general: 'Failed to load projects' }));
        }
      };

      fetchProjects();
    } else {
      setProjectResponse([]); // Reset projects if no client is selected
    }
  }, [clients]);

  const handleInputChange = (selectedOption, field) => {
    const value = selectedOption ? selectedOption.value : null;
    switch (field) {
      case 'state':
        setState(value);
        setDistrict(null);
        setMonth(null);
        setClients(null);
        setProject(null); // ✅ Clear project when state changes

        break;
      case 'district':
        setDistrict(value);
        // setProject(null); // ✅ Clear project when district changes
        break;
      case 'clients':
        setClients(value);
        setProject(null);
        // setProjectResponse([]);
        // setEmployees([]);
        // setEmployeeData([]);
        break;
      case 'month':
        setMonth(value);
        break;
      case 'project':
        setProject(value); // ✅ Handle project selection
        break;
      default:
        break;
    }
    setErrors(prev => ({ ...prev, [field]: null }));
  };

  // Fetch holidays
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/api/holiday/all`)
      .then(response => {
        setHolidays(response.data || []);
        console.log('Fetched holidays:', response.data);
      })
      .catch(err => {
        console.error('Error fetching holidays:', err);
        setError('Failed to load holidays');
      });
  }, []);

  // Check if selected date is a holiday
  useEffect(() => {
    const selected = new Date(date).toISOString().split('T')[0];
    const isHolidayDate = holidays.some(holiday => holiday.date === selected);
    setIsHoliday(isHolidayDate);
    console.log('Selected date:', selected, 'Is holiday:', isHolidayDate);
  }, [date, holidays]);

  // Fetch employees when state, district, and date are set
  useEffect(() => {
    if (hasSubmitted || !state || !district || isSunday || isHoliday || !clients) {
      setAttendanceData([]);
      console.log('Skipping employee fetch:', { hasSubmitted, state, district, isSunday, isHoliday });
      return;
    }
    const fetchEmployees = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await getEmployeeForAttendance(state, district, clients, project);
        // const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/employee-posting/employees?stateId=${state}&districtId=${district}&clientId=${clients}&projectId=${project}`);
        console.log('Raw employee API response:', response.data);
        const submittedKey = `attendance_${date}_${district}`;
        const alreadySubmittedIds = JSON.parse(localStorage.getItem(submittedKey) || '[]');
        console.log('Already submitted IDs:', alreadySubmittedIds);
        const filteredData = response.data
          .filter(emp => !alreadySubmittedIds.includes(emp.employeeId))
          .map(emp => ({
            employeeId: emp.employeeId,
            employeeName: emp.fullName,
            designation: emp.designation,
            contactNumber: emp.contactNumber || 'N/A',
            employeeUniqueId: emp.employeeUniqueId,
            attendanceStatus: '',
          }));
        setAttendanceData(filteredData);
        console.log('Filtered employees:', filteredData);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching employees:', err);
        setError('Error fetching employee data');
        setLoading(false);
      }
    };
    fetchEmployees();
  }, [state, district, clients, date, isSunday, isHoliday, hasSubmitted]);

  // const handleStateChange = selectedOption => {
  //   setState(selectedOption ? selectedOption.value : null);
  //   setDistrict(null);
  //   setHasSubmitted(false);
  //   console.log('State changed:', selectedOption ? selectedOption.value : null);
  // };

  // const handleDistrictChange = selectedOption => {
  //   setDistrict(selectedOption ? selectedOption.value : null);
  //   setHasSubmitted(false);
  //   console.log('District changed:', selectedOption ? selectedOption.value : null);
  // };

  const handleAttendanceChange = (selectedOption, index) => {
    const updatedData = [...attendanceData];
    updatedData[index].attendanceStatus = selectedOption ? selectedOption.value : '';
    setAttendanceData(updatedData);
    setStatusErrors([]);
    console.log('Attendance changed:', updatedData[index]);
  };

  const handleSubmit = async () => {
    if (!date) {
      alert('Please select a date for attendance.');
      return;
    }
    if (!state) {
      alert('Please select a state.');
      return;
    }
    if (!district) {
      alert('Please select a district.');
      return;
    }

    const markedEmployees = attendanceData.filter(
      employee => employee.attendanceStatus === 'Present' || employee.attendanceStatus === 'Absent' || employee.attendanceStatus === 'Casual'
    );

    if (markedEmployees.length === 0) {
      alert('Please select attendance for at least one employee.');
      return;
    }
    const fullNameAudit = localStorage.getItem("full_name");
    const role = localStorage.getItem("role");
    const employeeIdAudit = localStorage.getItem("employeeId");

    const payload = markedEmployees.map(emp => ({
      employeeUniqueId: emp.employeeUniqueId,
      employeeId: emp.employeeId,
      fullName: emp.employeeName,
      designation: emp.designation,
      attendanceDate: date,
      present: emp.attendanceStatus === 'Present',
      casual: emp.attendanceStatus === 'Casual',
      auditLog: {
        name: fullNameAudit,
        role: role,
        employeeId: employeeIdAudit
      }
    }));

    try {
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/daily-attendance`, payload);
      alert('Attendance submitted successfully');
      const submittedKey = `attendance_${date}_${district}`;
      const previouslySubmitted = JSON.parse(localStorage.getItem(submittedKey) || '[]');
      const newlySubmitted = markedEmployees.map(emp => emp.employeeId);
      const updatedSubmitted = Array.from(new Set([...previouslySubmitted, ...newlySubmitted]));
      localStorage.setItem(submittedKey, JSON.stringify(updatedSubmitted));
      setAttendanceData([]);
      setHasSubmitted(true);
    } catch (err) {
      console.error('Error submitting attendance:', err);
      setError('Error submitting attendance data');
    }
  };

  // const selectStyles = {
  //   menuPortal: base => ({ ...base, zIndex: 9999 }),
  //   menu: base => ({ ...base, marginTop: '5px', zIndex: 9999 }),
  //   control: provided => ({ ...provided, padding: '1px' }),
  //   valueContainer: provided => ({ ...provided, padding: '3px 6px' }),
  // };

  return (
    <div className="attendence">
      <div className="attendence-container">
        <h2 className="attendence-heading">Daily Attendance</h2>
        {error && <p className="error-message">{error}</p>}
        {/* <div className="attendance-div"> */}
        <div className="attendance-maincontainer ">
          <div className="attendance-container-part">
            <div className={`monthly-report-floating-label-container ${isFocused.state || state ? 'float-label' : ''}`}>
              <Select
                name="state"
                options={stateOptions}
                value={stateOptions.find(opt => opt.value === state) || null}
                onChange={option => handleInputChange(option, 'state')}
                onFocus={() => setIsFocused(prev => ({ ...prev, state: true }))}
                onBlur={() => setIsFocused(prev => ({ ...prev, state: false }))}
                placeholder=" "
                isClearable
                menuPortalTarget={document.body}
                styles={selectStyles}

              />
              <label><span className="required">*</span>State</label>
              {errors.state && <div className="error-message">{errors.state}</div>}
            </div>
          </div>
          <div className="attendance-container-part">
            <div className={`monthly-report-floating-label-container ${isFocused.district || district ? 'float-label' : ''}`}>
              <Select
                name="district"
                options={districtOptions}
                value={districtOptions.find(opt => opt.value === district) || null}
                onChange={option => handleInputChange(option, 'district')}
                onFocus={() => setIsFocused(prev => ({ ...prev, district: true }))}
                onBlur={() => setIsFocused(prev => ({ ...prev, district: false }))}
                placeholder=" "
                isClearable
                menuPortalTarget={document.body}
                styles={selectStyles}

              />
              <label><span className="required">*</span>District</label>
              {errors.district && <div className="error-message">{errors.district}</div>}
            </div>
          </div>
        </div>
        <div className="attendance-maincontainer ">
          <div className="attendance-container-part">
            <div className={`monthly-report-floating-label-container ${isFocused.clients || clients ? 'float-label' : ''}`}>
              <Select
                name="clients"
                options={clientResponse}
                value={clientResponse.find(opt => opt.value === clients) || null}
                onChange={option => handleInputChange(option, 'clients')}
                onFocus={() => setIsFocused(prev => ({ ...prev, clients: true }))}
                onBlur={() => setIsFocused(prev => ({ ...prev, clients: false }))}
                placeholder=" "
                isClearable
                menuPortalTarget={document.body}
                styles={selectStyles}
              />
              <label> <span className="required">*</span>Client</label>
              {errors.clients && <div className="error-message">{errors.clients}</div>}
            </div>

          </div>

          <div className="attendance-container-part">
            <div className={`monthly-report-floating-label-container ${isFocused.project || project ? 'float-label' : ''}`}>
              <Select
                name="project"
                options={projectResponse}
                value={projectResponse.find(opt => opt.value === project) || null}
                onChange={option => handleInputChange(option, 'project')}
                onFocus={() => setIsFocused(prev => ({ ...prev, project: true }))}
                onBlur={() => setIsFocused(prev => ({ ...prev, project: false }))}
                placeholder=" "
                isClearable
                menuPortalTarget={document.body}
                styles={selectStyles}
              />
              <label>
                Project
              </label>
              {errors.project && <div className="error-message">{errors.project}</div>}
            </div>
          </div>

        </div>
        <div className="attendance-maincontainer ">
          <div className="attendance-container-part">
            <div className={`monthly-report-floating-label-container ${isFocused.date || date ? 'float-label' : ''}`}>
              <input
                type="date"
                className="custom-date-input"
                value={date}
                onChange={e => {
                  if (e.target.value) {
                    setDate(e.target.value);
                    setHasSubmitted(false);          // ← NEW
                    setAttendanceData([]);           // ← clear old rows
                  }
                }}
                onFocus={() => setIsFocused(prev => ({ ...prev, date: true }))}
                onBlur={() => setIsFocused(prev => ({ ...prev, date: !!date }))}
                max={todayDate}
              />
              <label><span className="required">*</span>Date</label>
            </div>
          </div>
          <div className="attendance-container-part"> </div>
        </div>


        {/* </div> */}
        {isSunday && (
          <p className="error-message" style={{ color: 'red', textAlign: 'center' }}>
            Attendance is not required on Sundays. Please select another date.
          </p>
        )}
        {isHoliday && !isSunday && (
          <p className="error-message" style={{ color: 'red', textAlign: 'center' }}>
            This date is a holiday. Attendance is not required.
          </p>
        )}
        {state && district && !isSunday && !isHoliday && (
          <div className="attendance-table">
            {loading && <p>Loading...</p>}
            {error && <p className="error-message">{error}</p>}
            {!loading && !error && attendanceData.length === 0 && <p>No employees found.</p>}
            {!loading && !error && attendanceData.length > 0 && (
              <table className='daily-attendance-input'>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Emp ID</th>
                    <th>Emp Name</th>
                    <th>Designation</th>
                    <th>Attendance Status</th>
                  </tr>
                </thead>
                <tbody>
                  {attendanceData.map((employee, index) => (
                    <tr key={employee.employeeId}>
                      <td>{index + 1}</td>
                      <td>{employee.employeeId}</td>
                      <td>{employee.employeeName || 'N/A'}</td>
                      <td>{employee.designation || 'N/A'}</td>
                      <td>
                        <label>
                          <input
                            type="radio"
                            name={`attendance-${index}`}
                            value="Present"
                            checked={employee.attendanceStatus === 'Present'}
                            onChange={() => handleAttendanceChange({ value: 'Present' }, index)}
                          />{' '}
                          Present
                        </label>
                        <label style={{ marginLeft: '10px' }}>
                          <input
                            type="radio"
                            name={`attendance-${index}`}
                            value="Absent"
                            checked={employee.attendanceStatus === 'Absent'}
                            onChange={() => handleAttendanceChange({ value: 'Absent' }, index)}
                          />{' '}
                          Absent
                        </label>

                        <label style={{ marginLeft: '10px' }}>
                          <input
                            type="radio"
                            name={`attendance-${index}`}
                            value="Casual"
                            checked={employee.attendanceStatus === 'Casual'}
                            onChange={() => handleAttendanceChange({ value: 'Casual' }, index)}
                          />{' '}
                          Casual Leave
                        </label>

                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
            <button
              type="submit"
              className="submit-btn-daily-att"
              onClick={handleSubmit}
              disabled={!isValid}
            >
              Submit
            </button>
          </div>

        )}

      </div>
    </div>
  );
};

export default Attendence;